import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    jobRoleRequestList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    jobRoleRequestDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    aiJobRoleBudget: {
        data: null,
        aiLoading: false,
        aiAsked: false,
        error: null,
        success: false,
    },
    aiJobRoleDescription: {
        data: null,
        aiLoading: false,
        aiAsked: false,
        error: null,
        success: false,
    },
    aiJobRoleSkills: {
        data: null,
        aiLoading: false,
        aiAsked: false,
        error: null,
        success: false,
    }
  };

export const jobRoleRequestSlice = createSlice({
  name: 'jobRoleRequest',
  initialState,
  reducers: {
    getJobRoleRequestList: (state, action) => {
        state.jobRoleRequestList.requesting = true;
        state.jobRoleRequestList.error = null;
        state.jobRoleRequestList.items = [];
        state.jobRoleRequestList.success = false;
        state.jobRoleRequestList.filters = action.payload;
    },
    getJobRoleRequestListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.jobRoleRequestList.requesting = false;        
        state.jobRoleRequestList.items = data;
        state.jobRoleRequestList.success = true; 
        state.jobRoleRequestList.pagination.current_page = current_page;
        state.jobRoleRequestList.pagination.per_page = per_page;
        state.jobRoleRequestList.pagination.total = total;
    },
    getJobRoleRequestListFail: (state, action) => {        
        state.jobRoleRequestList.requesting = false;
        state.jobRoleRequestList.error = action.payload;
    },
    getJobRoleRequestDetails: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
    getJobRoleRequestDetailsSuccess: (state, action) => {
        state.jobRoleRequestDetails.requesting = false;
        state.jobRoleRequestDetails.data = action.payload;
        state.jobRoleRequestDetails.success = true; 
    },
    getJobRoleRequestDetailsFail: (state, action) => {        
        state.jobRoleRequestDetails.requesting = false;
        state.jobRoleRequestDetails.error = action.payload;
    },
    doJobRoleRequestCreate: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
    doJobRoleRequestUpdate: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
    doJobRoleRequestDelete: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },

    // AI Calls
    getJobRoleBudget: (state) => {
        state.aiJobRoleBudget.aiLoading = true;
        state.aiJobRoleBudget.error = null;
        state.aiJobRoleBudget.data = null;
        state.aiJobRoleBudget.success = false; 
    },
    getJobRoleBudgetSuccess: (state, action) => {
        state.aiJobRoleBudget.aiLoading = false;
        state.aiJobRoleBudget.data = action.payload;
        state.aiJobRoleBudget.aiAsked = true;
        state.aiJobRoleBudget.success = true; 
    },
    getJobRoleBudgetFail: (state, action) => {        
        state.aiJobRoleBudget.aiLoading = false;
        state.aiJobRoleBudget.aiAsked = false;
        state.aiJobRoleBudget.error = action.payload;
    },

    getJobRoleDescription: (state) => {
        state.aiJobRoleDescription.aiLoading = true;
        state.aiJobRoleDescription.error = null;
        state.aiJobRoleDescription.data = null;
        state.aiJobRoleDescription.success = false; 
    },
    getJobRoleDescriptionSuccess: (state, action) => {
        state.aiJobRoleDescription.aiLoading = false;
        state.aiJobRoleDescription.data = action.payload;
        state.aiJobRoleDescription.aiAsked = true;
        state.aiJobRoleDescription.success = true; 
    },
    getJobRoleDescriptionFail: (state, action) => {        
        state.aiJobRoleDescription.aiLoading = false;
        state.aiJobRoleDescription.aiAsked = false;
        state.aiJobRoleDescription.error = action.payload;
    },

    getJobRoleSkills: (state) => {
        state.aiJobRoleSkills.aiLoading = true;
        state.aiJobRoleSkills.error = null;
        state.aiJobRoleSkills.data = null;
        state.aiJobRoleSkills.success = false; 
    },
    getJobRoleSkillsSuccess: (state, action) => {
        state.aiJobRoleSkills.aiLoading = false;
        state.aiJobRoleSkills.data = action.payload;
        state.aiJobRoleSkills.aiAsked = true;
        state.aiJobRoleSkills.success = true; 
    },
    getJobRoleSkillsFail: (state, action) => {        
        state.aiJobRoleSkills.aiLoading = false;
        state.aiJobRoleSkills.aiAsked = false;
        state.aiJobRoleSkills.error = action.payload;
    },

    doJobRoleRequestEditJobPost: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.success = false; 
    },

    doJobRoleRequestSaveJobPost: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.success = false; 
    },

  },
})

export const { 
    getJobRoleRequestList, getJobRoleRequestListSuccess, getJobRoleRequestListFail,
    getJobRoleRequestDetails, getJobRoleRequestDetailsSuccess, getJobRoleRequestDetailsFail,
    doJobRoleRequestCreate, doJobRoleRequestUpdate, doJobRoleRequestDelete,
    getJobRoleBudget, getJobRoleBudgetSuccess, getJobRoleBudgetFail,
    getJobRoleDescription, getJobRoleDescriptionSuccess, getJobRoleDescriptionFail,
    getJobRoleSkills, getJobRoleSkillsSuccess, getJobRoleSkillsFail,
    doJobRoleRequestEditJobPost, doJobRoleRequestSaveJobPost
} = jobRoleRequestSlice.actions

export default jobRoleRequestSlice.reducer